import { createApp } from 'vue';
import router from './router';
import store from './store';

import VueSweetalert2 from 'vue-sweetalert2';
import Toast, { POSITION } from "vue-toastification";
import "sweetalert2/dist/sweetalert2.min.css";
import "vue-toastification/dist/index.css";

const option_toast = {
  transition: "Vue-Toastification__fade",
  maxToasts: 2,
  newestOnTop: true,
  position: POSITION.TOP_CENTER
};

import '@popperjs/core/dist/umd/popper.min.js';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Dropdown, Collapse, Tab, Modal } from 'bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import './assets/sass/app.scss';
import App from './App.vue';
import './page.js';

const app = createApp(App);
app.config.globalProperties.$api_url = import.meta.env.VITE_API_URL;
app.config.globalProperties.$modal_popup = (modalId) => {
  const modalElement = document.getElementById(modalId);
  return new Modal(modalElement);
};
app.use(Toast, option_toast);
app.use(VueSweetalert2);
app.use(store);
app.use(router);
app.mount('#app');
